import React, { useState } from "react";
import { copyCoords, formatCoords } from "@/lib/avenza.js";

export function AvenzaActions({ lat, lng, ui }) {
  const [copied, setCopied] = useState(false);
  if (lat == null || lng == null) return null;
  return (
    <div className="og-toolbar">
      <button
        type="button"
        className="og-btn"
        data-testid="copy-coords"
        onClick={async () => {
          const ok = await copyCoords(lat, lng);
          setCopied(ok);
        }}
      >
        {copied ? ui.app.copied : ui.avenza.copy}
      </button>
      <small className="og-hint">{formatCoords(lat, lng)}</small>
    </div>
  );
}
